// @flow

import { useState, useEffect } from 'react';

export const useScroll = () => {
  const [scroll, setScroll] = useState({
    x: 0,
    y: 0,
    direction: '',
  });

  const listener = () => {
    if (document.body) {
      const { body } = document;
      setScroll(prev => ({
        x: body.getBoundingClientRect().left,
        y: -body.getBoundingClientRect().top,
        direction: prev.y > -body.getBoundingClientRect().top ? 'up' : 'down',
      }));
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', listener);
    return () => window.removeEventListener('scroll', listener);
  }, []);

  return scroll;
};
